"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdOwner = void 0;
var AdOwner;
(function (AdOwner) {
    AdOwner["SmartPadel"] = "SMART_PADEL";
    AdOwner["Site"] = "SITE";
})(AdOwner || (exports.AdOwner = AdOwner = {}));
